var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"width":90,"height":90,"speed":2,"primaryColor":"#f3f3f3","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"2","ry":"2","width":"90","height":"90"}})])}
var staticRenderFns = []

export { render, staticRenderFns }